<h1>
  <span i18n="@@office-setting.customer-details">Customer Details</span>
</h1>

<form [formGroup]="modifyCustomerForm">
  @if (customers?.length > 0) {
    <div class="customer-form-container" formGroupName="customer">
      <div class="customer-select">
        <mat-form-field appearance="outline">
          <mat-select-trigger
            class="dropdown-trigger-icon"
          ></mat-select-trigger>
          <mat-select
            formControlName="emailSelect"
            placeholder="Please select customers"
          >
            @for (customer of customers; track customer) {
              <mat-option [value]="customer.email">
                {{ customer.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      @if (selectedCustomer) {
        <div class="customer-details-form">
          <div class="customer-details-form-item">
            <h2 i18n="@@office-setting.contact-info">Contact Info</h2>
            <div class="two-column">
              <div class="form-input-field">
                <mat-label>
                  <span i18n="@@office-setting.name">Name</span>
                  <span style="color: red">*</span>
                </mat-label>
                <mat-form-field appearance="outline" ngDefaultControl>
                  <input
                    matInput
                    type="text"
                    formControlName="name"
                    (keyup)="showErrors = false"
                  />
                  @if (formHasError("name", ["required"])) {
                    <mat-error i18n="@@office-setting.field-required">
                      This field is required
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="form-input-field">
                <mat-label>
                  <span i18n="@@office-setting.email">Email address</span>
                  <span style="color: red">*</span>
                </mat-label>
                <mat-form-field
                  appearance="outline"
                  labelPosition="before"
                  ngDefaultControl
                >
                  <input
                    class="uneditable-field"
                    matInput
                    type="text"
                    formControlName="email"
                    readonly
                  />
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="customer-details-form-item">
            <h2 i18n="@@office-setting.address">Address</h2>
            <div class="form-input-field">
              <mat-label>
                <span i18n="@@office-setting.addressLine1">Address Line 1</span>
              </mat-label>
              <mat-form-field appearance="outline" ngDefaultControl>
                <input matInput type="text" formControlName="addressLine1" />
              </mat-form-field>
            </div>
            <div class="form-input-field">
              <mat-label>
                <span i18n="@@office-setting.addressLine2">Address Line 2</span>
              </mat-label>
              <mat-form-field
                appearance="outline"
                labelPosition="before"
                ngDefaultControl
              >
                <input matInput type="text" formControlName="addressLine2" />
              </mat-form-field>
            </div>
            <div class="two-column">
              <div class="form-input-field">
                <mat-label>
                  <span i18n="@@office-setting.city">City</span>
                </mat-label>
                <mat-form-field appearance="outline" ngDefaultControl>
                  <input matInput type="text" formControlName="city" />
                </mat-form-field>
              </div>
              <div class="form-input-field">
                <mat-label>
                  <span i18n="@@office-setting.state">State</span>
                </mat-label>
                <mat-form-field
                  appearance="outline"
                  labelPosition="before"
                  ngDefaultControl
                >
                  <input matInput type="text" formControlName="state" />
                </mat-form-field>
              </div>
            </div>
            <div class="two-column">
              <div class="form-input-field">
                <mat-label>
                  <span i18n="@@office-setting.zipcode">Zip/Postcode</span>
                </mat-label>
                <mat-form-field appearance="outline" ngDefaultControl>
                  <input matInput type="text" formControlName="zipcode" />
                </mat-form-field>
              </div>
              <div class="form-input-field">
                <mat-label i18n="@@office-setting.country">Country</mat-label>
                <mat-form-field appearance="outline">
                  <mat-select-trigger
                    class="dropdown-trigger-icon"
                  ></mat-select-trigger>
                  <mat-select formControlName="country">
                    @for (country of countries; track country) {
                      <mat-option [value]="country.countryCode">
                        {{ country.countryName }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      }
      @if (selectedCustomer) {
        <button
          #saveChangedButton
          (click)="updateCustomer()"
          [disabled]="!hasCustomerChanges()"
        >
          Save changes
        </button>
      }
    </div>
  } @else {
    @if (customersLoaded) {
      <div class="noCustomers">
        <img
          src="/assets/media/officeSettings/no-customers.png"
          alt="No customers"
        />
        <strong i18n="@@office-setting.no-customer-record">
          No customer records found
        </strong>
        <span i18n="@@office-setting.select-another-office"
          >Please select another office or create a customer record.</span
        >
      </div>
    }
  }
  <ng-template #noCustomers>
    @if (customersLoaded) {
      <div class="noCustomers">
        <img
          src="/assets/media/officeSettings/no-customers.png"
          alt="No customers"
        />
        <strong i18n="@@office-setting.no-customer-record">
          No customer records found
        </strong>
        <span i18n="@@office-setting.select-another-office"
          >Please select another office or create a customer record.</span
        >
      </div>
    }
  </ng-template>
</form>
